export const APPEAR_FILTER = 'APPEAR_FILTER';
const APPEAR_FILTER_HOTEL_PC = 'appear_filtering_favoritehotel_pc';
const APPEAR_FILTER_HOTEL_SP = 'appear_filtering_favoritehotel_sp';
const APPEAR_FILTER_PLAN_PC = 'appear_filtering_plan_list_pc';
const APPEAR_FILTER_PLAN_SP = 'appear_filtering_plan_list_sp';

export const CLICK_FILTER = 'CLICK_FILTER';
const CLICK_FILTER_HOTEL_PC = 'click_filtering_favoritehotel_pc';
const CLICK_FILTER_HOTEL_SP = 'click_filtering_favoritehotel_sp';
const CLICK_FILTER_PLAN_PC = 'click_filtering_plan_list_pc';
const CLICK_FILTER_PLAN_SP = 'click_filtering_plan_list_sp';

export const APPEAR_SORT = 'APPEAR_SORT';
const APPEAR_SORT_HOTEL_PC = 'appear_sorting_favoritehotel_pc';
const APPEAR_SORT_HOTEL_SP = 'appear_sorting_favoritehotel_sp';
const APPEAR_SORT_PLAN_PC = 'appear_sorting_favoriteplan_pc';
const APPEAR_SORT_PLAN_SP = 'appear_sorting_favoriteplan_sp';

export const CLICK_SORT = 'CLICK_SORT';
const CLICK_SORT_HOTEL_PC = 'click_sorting_favoritehotel_pc';
const CLICK_SORT_HOTEL_SP = 'click_sorting_favoritehotel_sp';
const CLICK_SORT_PLAN_PC = 'click_sorting_favoriteplan_pc';
const CLICK_SORT_PLAN_SP = 'click_sorting_favoriteplan_sp';

export const APPEAR_FAVBUTTON = 'APPEAR_FAVBUTTON';
const APPEAR_FAVBUTTON_HOTEL_PC = 'appear_favoritebutton_hotel_list_pc';
const APPEAR_FAVBUTTON_HOTEL_SP = 'appear_favoritebutton_hotel_list_sp';
const APPEAR_FAVBUTTON_PLAN_PC = 'appear_favoritebutton_plan_list_pc';
const APPEAR_FAVBUTTON_PLAN_SP = 'appear_favoritebutton_plan_list_sp';

export const CLICK_FAVBUTTON = 'CLICK_FAVBUTTON';
const CLICK_FAVBUTTON_HOTEL_PC = 'click_favoritebutton_hotel_list_pc_remove';
const CLICK_FAVBUTTON_HOTEL_SP = 'click_favoritebutton_hotel_list_sp_remove';
const CLICK_FAVBUTTON_PLAN_PC = 'click_favoritebutton_plan_list_pc_remove';
const CLICK_FAVBUTTON_PLAN_SP = 'click_favoritebutton_plan_list_sp_remove';

const DOMESTIC_HOTEL = 'favorite_list_domestic_hotel';
const DOMESTIC_PLAN = 'favorite_list_domestic_plan';
const OVERSEAS_HOTEL = 'favorite_list_overseas_hotel';
const OVERSEAS_PLAN = 'favorite_list_overseas_plan';

export const getRatPage = (isDomestic: boolean, isPlanList: boolean) =>
  isDomestic
    ? isPlanList
      ? DOMESTIC_PLAN
      : DOMESTIC_HOTEL
    : isPlanList
      ? OVERSEAS_PLAN
      : OVERSEAS_HOTEL;

export const getRatId = (ratId: string, isPlanList: boolean, isMobile: boolean) => {
  switch (ratId) {
    case APPEAR_FILTER:
      return isPlanList
        ? isMobile
          ? APPEAR_FILTER_PLAN_SP
          : APPEAR_FILTER_PLAN_PC
        : isMobile
          ? APPEAR_FILTER_HOTEL_SP
          : APPEAR_FILTER_HOTEL_PC;
    case CLICK_FILTER:
      return isPlanList
        ? isMobile
          ? CLICK_FILTER_PLAN_SP
          : CLICK_FILTER_PLAN_PC
        : isMobile
          ? CLICK_FILTER_HOTEL_SP
          : CLICK_FILTER_HOTEL_PC;
    case APPEAR_SORT:
      return isPlanList
        ? isMobile
          ? APPEAR_SORT_PLAN_SP
          : APPEAR_SORT_PLAN_PC
        : isMobile
          ? APPEAR_SORT_HOTEL_SP
          : APPEAR_SORT_HOTEL_PC;
    case CLICK_SORT:
      return isPlanList
        ? isMobile
          ? CLICK_SORT_PLAN_SP
          : CLICK_SORT_PLAN_PC
        : isMobile
          ? CLICK_SORT_HOTEL_SP
          : CLICK_SORT_HOTEL_PC;
    case APPEAR_FAVBUTTON:
      return isPlanList
        ? isMobile
          ? APPEAR_FAVBUTTON_PLAN_SP
          : APPEAR_FAVBUTTON_PLAN_PC
        : isMobile
          ? APPEAR_FAVBUTTON_HOTEL_SP
          : APPEAR_FAVBUTTON_HOTEL_PC;
    case CLICK_FAVBUTTON:
      return isPlanList
        ? isMobile
          ? CLICK_FAVBUTTON_PLAN_SP
          : CLICK_FAVBUTTON_PLAN_PC
        : isMobile
          ? CLICK_FAVBUTTON_HOTEL_SP
          : CLICK_FAVBUTTON_HOTEL_PC;
  }
};
